module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("dU1ZU"))).then(() => parcelRequire('bM8uo'));